export default __webpack_public_path__ + "static/media/smoke-masks-icon.06d3b705.svg";